const actions = {
    GET_DAILY_PLAN_REQUEST_LIST_FOR_SOCKET: "GET_DAILY_PLAN_REQUEST_LIST_FOR_SOCKET",

    GET_SIM_SWAP_REQUEST_FOR_SOCKET: "GET_SIM_SWAP_REQUEST_FOR_SOCKET",

    GET_ACTIVATION_REQUEST_LIST_FOR_SOCKET: "GET_ACTIVATION_REQUEST_LIST_FOR_SOCKET",

    GET_MSISDN_POOL_DATA_FOR_SOCKET: "GET_MSISDN_POOL_DATA_FOR_SOCKET",

    getDailyPlanRequestListForSocket: (searchData) => ({
        type: actions.GET_DAILY_PLAN_REQUEST_LIST_FOR_SOCKET,
        payload: { searchData }
    }),

    getSimSwapRequestForSocket: (searchData) => ({
        type: actions.GET_SIM_SWAP_REQUEST_FOR_SOCKET,
        payload: { searchData }
    }),

    getActivationRequestForSocketList: (searchData) => ({
        type: actions.GET_ACTIVATION_REQUEST_LIST_FOR_SOCKET,
        payload: { searchData }
    }),

    getMsisdnPoolForSocketList: (searchData) => ({
        type: actions.GET_MSISDN_POOL_DATA_FOR_SOCKET,
        payload: { searchData }
    }),
};

export default actions;